/**
 * Created by Daniel on 07/20/2021. add module for other reference
 * -------------------------------------
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopupModule } from '@progress/kendo-angular-popup';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { AgGridModule } from 'ag-grid-angular';

import { WidgetsModule } from '../../../widgets/widgets.module';
import { FieldModule } from '../field/field.module';
import { TaskGridKanbanComponent } from './task-grid-kanban.component';
import { TamCustomGridColumnFilterComponent } from '../../../widgets/ag-grid-column-filter/custom-grid-column-filter.component';
import { TamCustomGroupRowInnerRenderer } from '../../../widgets/ag-grid-column-filter/custom-group-row-inner-renderer.component';

@NgModule({
    imports: [
        AgGridModule,
        CommonModule,
        DropDownsModule,
        FieldModule,
        PopupModule,
        WidgetsModule,
    ],
    declarations: [
        TaskGridKanbanComponent,
    ],
    exports: [
        TaskGridKanbanComponent,
    ],
    providers: []
})
export class TaskGridKanbanModule { }
